import {controller, target} from '@github/catalyst'

@controller
class MaskedValueElement extends HTMLElement {
  @target mask: HTMLElement
  @target reveal: HTMLElement

  toggle() {
    this.mask.hidden = !this.mask.hidden
    this.reveal.hidden = !this.reveal.hidden
  }
}
